import produitDivers from '@/store/modules/produitDivers';
import contratNature from '@/store/modules/contratNature';
import face from '@/store/modules/gabed/face';
import materiel from '@/store/modules/gabed/materiel';
import materielTlpe from '@/store/modules/gabed/materielTlpe';
import dispositif from '@/store/modules/gabed/dispositif';
import collectivite from '@/store/modules/gabed/collectivite';
import declarationAuFilDeLeau from '@/store/modules/gabed/declarationAuFilDeLeau';
import dispositifType from '@/store/modules/dispositifType';
import constatationCharge from '@/store/modules/baux/constatationCharge';
import materielFormat from '@/store/modules/materielFormat';
import materielType from '@/store/modules/materielType';
import echeancesAPayer from '@/store/modules/baux/echeancesAPayer';
import produitLocationAchat from '@/store/modules/baux/produitLocationAchat';
import emplacementDispositifMaterielFacePicker from '@/store/modules/gabed/emplacementDispositifMaterielFacePicker';
import produitReseauTempo from '@/store/modules/produitReseauTempo';
import ligneCommande from '@/store/modules/ligneCommande';
import relanceOption from '@/store/modules/relanceOption';
import factureAchatARapprocher from '@/store/modules/baux/factureAchatARapprocher';
import delaiReglement from '@/store/modules/delaiReglement';
import paiementSurFacture from '@/store/modules/baux/paiementSurFacture';
import commandeAFacturer from '@/store/modules/commandeAFacturer';
import demandeTempo from '@/store/modules/bodac/demandeTempo';
import typeTaxationTlpe from '@/store/modules/typeTaxationTlpe';
import commandeAchat from '@/store/modules/commandeAchat';
import commandeAchatAnterieureVendeur from '@/store/modules/compta/commandeAchatAnterieureVendeur';
import commandeAchatAnterieureFournisseur from '@/store/modules/compta/commandeAchatAnterieureFournisseur';
import contratMateriel from '@/store/modules/baux/contratMateriel';
import confrere from '@/store/modules/commun/confrere';
import regimeTva from '@/store/modules/bodac/parametrage/regimeTva';
import projets from '@/store/modules/logistique/projets';
import compteAnalytique from '@/store/modules/parametrage/compteAnalytique';
import bafCommande from '@/store/modules/bafCommande';
import commandeParLigneCommande from '@/store/modules/bodac/commandeParLigneCommande';
import factureAchat from '@/store/modules/baux/factureAchat';
import produitSalon from '@/store/modules/bodac/catalogue/produitSalon';
import produitReseauMairie from '@/store/modules/bodac/catalogue/produitReseauMairie';
import produitReseauNumerique from '@/store/modules/produitReseauNumerique';
import produitSponsoring from '@/store/modules/bodac/catalogue/produitSponsoring';
import produitAutre from '@/store/modules/bodac/catalogue/produitAutre';
import produitPresse from '@/store/modules/bodac/catalogue/produitPresse';
import faceBailleur from '@/store/modules/gabed/face-bailleur';
import suiviProduction from '@/store/modules/logistique/suiviProduction';
import technicien from '@/store/modules/logistique/technicien';
import ordreTravailTech from '@/store/modules/logistique/ordreTravailTech';
import accessoire from '@/store/modules/accessoire';
import commandeTlpe from '@/store/modules/gabed/commandeTlpe';
import echeancePaiement from '@/store/modules/echeancePaiement';
import ecranNumeriqueBailleur from '@/store/modules/gabed/ecranNumeriquebailleur';
import commandeFournisseur from '@/store/modules/commandeFournisseur';
import fournisseurMateriel from '@/store/modules/gabed/fournisseurMateriel';
import audit from '@/store/modules/logistique/audit';
import retrocession from '@/store/modules/bodac/retrocession/retrocession';
import parametrageGeneral from '@/store/modules/parametrageGeneral';
import operationDiverse from '@/store/modules/compta/operationDiverse';
import ecritureComptable from '@/store/modules/compta/ecritureComptable';
import factor from '@/store/modules/bodac/factor/factor';
import campagne from '@/store/modules/bodac/campagne/campagne';
import transmission from '@/store/modules/bodac/transmission/transmission';
import produitFaceSuiviAffectations from '@/store/modules/produitFaceSuiviAffectations';
import ordreTravailImpression from '@/store/modules/logistique/ordreTravailImpression';
import formatAffiche from '@/store/modules/parametrage/formatAffiche';
import facturesAchatsFournisseur from '@/store/modules/achat/facturesAchatsFournisseur';
import besoin from '@/store/modules/bodac/besoin/besoin';
import clients from './modules/clients';
import echeanceFacturation from './modules/bodac/clients/EcheanceFacturation';
import devis from './modules/devis';
import commande from './modules/commande';
import echeancier from './modules/echeancier';
import facture from './modules/facture';
import produit from './modules/produit';
import produitEcranNumerique from './modules/produitEcranNumerique';
import produitFace from './modules/produitFace';
import attachments from './modules/attachments';
import remiseBancaire from './modules/remiseBancaire';
import journalReglements from './modules/journalReglements';
import journalPaiements from './modules/journalPaiements';
import mouvementClient from './modules/mouvementClient';
import mouvementStock from './modules/mouvementStock';
import role from './modules/role';
import retardPaiement from './modules/retardPaiement';
import relance from './modules/relance';
import ui from './modules/ui';
import emplacement from './modules/gabed/emplacement';
import renouvellementCommande from './modules/renouvellementCommande';
import exerciceComptable from './modules/compta/exerciceComptable';
import modeReglement from './modules/modeReglement';
import domiciliationBancaire from './modules/domiciliationBancaire';
import planningReseauTempo from './modules/planningReseauTempo';
import schemaComptable from './modules/schemaComptable';
import natureProduit from './modules/natureProduit';
import journalEcriture from './modules/compta/journalEcriture';
import lotsComptable from './modules/compta/lotsComptable';
import produitReseauLc from './modules/produitReseauLc';
import commentaire from './modules/commentaire';
import libelleRemise from './modules/libelleRemise';
import tourneeModele from './modules/logistique/tourneeModele';
import demande from './modules/logistique/demande';
import afficheur from './modules/logistique/afficheur';
import tourneeFaceSemaine from './modules/logistique/tourneeFaceSemaine';
import contrat from './modules/baux/contrat';
import bailleur from './modules/baux/bailleur';
import ordreTravailAff from './modules/logistique/ordreTravailAffichage';
import compteClient from './modules/compteClient';
import intervention from './modules/logistique/intervention';
import typeOt from './modules/logistique/typeOt';
import typeProduit from './modules/presse/typeProduit';
import couleurEncart from './modules/presse/couleurEncart';
import regleFacturation from './modules/presse/regleFacturation';
import emplacementPresse from './modules/presse/emplacementPresse';
import periodicite from './modules/presse/periodicite';
import surface from './modules/presse/surface';
import modeDistribution from './modules/presse/modeDistribution';
import typeFormatPresse from './modules/presse/typeFormatPresse';
import typeEvenementSponsoring from './modules/presse/typeEvenementSponsoring';
import fournisseurSupport from './modules/achat/fournisseurSupport';
import fournisseurs from './modules/achat/fournisseurs';
import commandesAchatsFournisseur from './modules/achat/commandesAchatsFournisseur';
import typeContact from './modules/parametrage/typeContact';
import parution from './modules/presse/parution';
import planMedia from './modules/planMedia';
import marche from './modules/achat/marche';
import moisComptable from './modules/presse/moisComptable';
import produitFournisseurSupport from './modules/presse/produitFournisseurSupport';
import echeanceARapprocher from './modules/baux/echeanceARapprocher';
import regroupementProduit from './modules/bodac/catalogue/regroupementProduit';
import produitsPresse from './modules/presse/produitsPresse';
import factureParLigne from './modules/bodac/factureParLigne';
import demarcheur from './modules/baux/demarcheur';
import signatureElectronique from './modules/commun/signatureElectronique';
import indiceEtValeur from './modules/indiceEtValeur';
import devisParLignesDevis from './modules/bodac/devisParLignesDevis';
import tag from './modules/tag';
import nomenclatureType from './modules/nomenclatureType';
import bonStock from './modules/gabed/bonStock';
import demandeImpression from './modules/logistique/demandeImpression';
import secteur from './modules/secteur';
import lieuDeLivraison from './modules/achat/lieuDeLivraison';
import otExpeditionLivraison from './modules/logistique/otExpeditionLivraison';
import commandeAchatBailleur from './modules/baux/commandeAchatBailleur';
import pays from './modules/pays';
import bonExpedition from './modules/logistique/bonExpedition';
import sprint from './modules/parametrage/sprint';
import produitAchat from './modules/produitAchat';
import service from './modules/parametrage/service';
import ligneCommandeAchat from './modules/achat/ligneCommandeAchat';
import commandeAchatForCmdVente from './modules/commandeAchatForCmdVente';
import suiviAchats from './modules/achat/suiviAchats';

const modules = {
  attachments,
  remiseBancaire,
  journalReglements,
  journalPaiements,
  role,
  clients,
  devis,
  commande,
  paiementSurFacture,
  echeancier,
  commandeAchat,
  commandeAchatAnterieureVendeur,
  commandeAchatAnterieureFournisseur,
  planningReseauTempo,
  facture,
  mouvementClient,
  mouvementStock,
  produit,
  produitEcranNumerique,
  produitFace,
  retardPaiement,
  relance,
  emplacement,
  ui,
  contratMateriel,
  bailleur,
  renouvellementCommande,
  exerciceComptable,
  modeReglement,
  domiciliationBancaire,
  schemaComptable,
  natureProduit,
  journalEcriture,
  lotsComptable,
  produitReseauLc,
  commentaire,
  libelleRemise,
  tourneeModele,
  demande,
  afficheur,
  intervention,
  tourneeFaceSemaine,
  contrat,
  ordreTravailAff,
  produitDivers,
  contratNature,
  commandeFournisseur,
  face,
  materiel,
  materielTlpe,
  dispositifType,
  constatationCharge,
  materielFormat,
  materielType,
  echeancesAPayer,
  produitLocationAchat,
  produitReseauTempo,
  ligneCommande,
  commandeAFacturer,
  relanceOption,
  factureAchatARapprocher,
  delaiReglement,
  demandeTempo,
  typeTaxationTlpe,
  collectivite,
  declarationAuFilDeLeau,
  confrere,
  compteAnalytique,
  regimeTva,
  bafCommande,
  commandeParLigneCommande,
  emplacementDispositifMaterielFacePicker,
  factureAchat,
  echeanceFacturation,
  dispositif,
  produitReseauMairie,
  compteClient,
  faceBailleur,
  suiviProduction,
  technicien,
  ordreTravailTech,
  typeOt,
  accessoire,
  projets,
  typeProduit,
  commandeTlpe,
  couleurEncart,
  regleFacturation,
  emplacementPresse,
  periodicite,
  surface,
  modeDistribution,
  typeFormatPresse,
  typeEvenementSponsoring,
  fournisseurSupport,
  fournisseurs,
  typeContact,
  parution,
  produitSalon,
  produitSponsoring,
  produitAutre,
  planMedia,
  produitPresse,
  marche,
  moisComptable,
  ecranNumeriqueBailleur,
  fournisseurMateriel,
  produitFournisseurSupport,
  echeancePaiement,
  audit,
  echeanceARapprocher,
  retrocession,
  parametrageGeneral,
  regroupementProduit,
  operationDiverse,
  factor,
  transmission,
  produitsPresse,
  factureParLigne,
  ecritureComptable,
  demarcheur,
  signatureElectronique,
  indiceEtValeur,
  devisParLignesDevis,
  tag,
  campagne,
  besoin,
  nomenclatureType,
  bonStock,
  demandeImpression,
  secteur,
  lieuDeLivraison,
  produitFaceSuiviAffectations,
  otExpeditionLivraison,
  ordreTravailImpression,
  commandeAchatBailleur,
  produitReseauNumerique,
  pays,
  bonExpedition,
  sprint,
  produitAchat,
  formatAffiche,
  service,
  commandesAchatsFournisseur,
  ligneCommandeAchat,
  commandeAchatForCmdVente,
  facturesAchatsFournisseur,
  suiviAchats,
};

export default function registerStore(store) {
  Object.keys(modules).forEach((module) => {
    store.registerModule(module, modules[module]);
  });
}
